export const getMappedSolvents = (solvents, getCompound) =>
  solvents.map(i => ({ fraction: i.fraction, compound: getCompound(i.compound_id) }));
